module.exports = __webpack_public_path__ + "static/media/arabia_gevorderd.4bee9bae.jpg";